export const ADMINISTRATOR = 'ADMINISTRATOR'
export const GGC = 'GGC'
export const REGULAR = 'REGULAR'
export const GROUPADMIN = 'GROUP_ADMINISTRATOR'
